import { Component } from '@angular/core';

@Component({
  selector: 'app-bps-admin-dashboard',
  standalone: false,
  templateUrl: './bps-admin-dashboard.component.html',
  styleUrl: './bps-admin-dashboard.component.scss'
})
export class BpsAdminDashboardComponent {

}
